module.exports = __webpack_public_path__ + "img/zappos_logo@2x.0948a2fe.png";